import * as React from 'react';
import * as paths from '../paths';

import {RouteComponentProps, withRouter} from 'react-router-dom';
import furoApi from '../api/FuroApi';
import LoginForm from './LoginForm';
import {ErrorResponse, LoginResponse} from '../api/dtos/dtos';
import {ErrorAlert} from '../common/ErrorAlert';
import accountProvider from './AccountProvider';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';

import {GlobalAlertContextConsumer, GlobalAlertContextState} from "../app/alert/GlobalAlertContextProvider";


interface LoginPageState {
  error?: ErrorResponse;
}

class LoginPage extends React.Component<RouteComponentProps, LoginPageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  public globalAlertContextState?: GlobalAlertContextState

  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      error: undefined
    };
  }

  public render() {
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <GlobalAlertContextConsumer>
          {(state) => {
            this.globalAlertContextState = state;
            return null;
          }}
        </GlobalAlertContextConsumer>

        <LoginForm onLoginBtnTapped={this.handleLogin()}/>
        {this.state.error && <ErrorAlert error={this.state.error}/>}
      </>
    );
  }

  private handleLogin = () => (userName: string, password: string) => {
    const promise = furoApi.auth.logIn(userName, password)
      .then(this.onLoginSuccess)
      .catch(this.onLoginError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onLoginSuccess = (response: LoginResponse) => {
    accountProvider.updateAccountStorage({
      userName: response.userName,
      token: response.token,
      role: response.role,
      companyId: response.defaultCompanyId,
    });

    this.globalAlertContextState?.refreshAll();

    const authenticated = accountProvider.isAdmin() || accountProvider.isSales();
    const path = authenticated ? paths.rentalsPath : paths.maintenancesPath;
    this.props.history.replace(path);
  };


  private onLoginError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default withRouter(LoginPage);



// WEBPACK FOOTER //
// ./src/account/LoginPage.tsx